import { Component, Input } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { Order } from 'src/app/core/orders.service';
import { Refund, RefundService } from 'src/app/core/refund.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-order-details-qinetic-refund',
  templateUrl: './order-details-qinetic-refund.component.html',
  styleUrls: ['./order-details-qinetic-refund.component.scss'],
})
export class OrderDetailsQineticRefundComponent {
  @Input() order?: Order;

  is_read_running = false;
  refund?: Refund;

  constructor(
    private refund_service: RefundService,
    private error_service: ErrorService,
    private utils_service: UtilsService,
  ) {}

  ngOnInit(): void {
    const store_id = this.order?.store_id;
    const refund_id = this.order?.refund_id;
    if (store_id && refund_id) this.readRefund(store_id, refund_id);
  }

  readRefund(store_id: string, refund_id: string): void {
    this.is_read_running = true;
    this.refund_service.read(store_id, refund_id).subscribe({
      next: response => {
        this.refund = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.refund = undefined;
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  getFormattedNet(refund?: Refund): string {
    if (refund?.amount?.net != null) {
      const refund_amount = refund.amount.net / 100;

      const formatted_amount = refund_amount.toLocaleString('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const refund_currency = this.getCurrencyLabel(refund);

      return `${formatted_amount} ${refund_currency}`;
    } else {
      return '-';
    }
  }

  getCurrencyLabel(refund: Refund): string {
    return this.utils_service.getCurrencyLabelFromRefund(refund);
  }
}
